import React, { useState } from "react";
import { useForm } from "react-hook-form";
import backend from "../../api";
import Modal from "react-responsive-modal";
import { Link, useHistory } from "react-router-dom";
import { global_actions } from "../../redux-store";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumb from "../common/breadcrumb";
import { Notification } from "../../utils";

const questions = [
  // {
  //   question:
  //     'Is there a minimum amount I need to offer as a reward or prize to eksplode Members under the eac program, or to the eksplode Stars under the vac program?',
  //   answer: `No. But be mindful that eksplode Members and eksplode Stars are lured to promote products/services based on the amount of the reward/prize offered. The higher the amount, the higher the probability of promotion.`,
  // },
  // {
  //   question: `Can I increase or decrease the amount offered as a reward or prize at any time?`,
  //   answer: `You may only increase the reward or prize amount at any time. However, you may not decrease the amount offered on our vac program, but may do so under our eac program. Please note that any decrease on our eac program will not take effect until one minute past the 24th hour after the decrease has been made. This period allows us to notify our eksplode Members of the change and allow them to pull or suspend promoting your product/service.`,
  // },
  // {
  //   question: `What happens if a customer wants a refund on a product or service sold though eksplode?`,
  //   answer: `We require our Merchants to post and maintain a customer notice, warning them that all returns/refunds will be subjected to a surcharge/restocking fee equal to or greater than the reward/prize amount paid to our Members/Stars, plus our processing fee of 5%. This policy will be strictly enforced and is necessary to prevent individuals from scamming our system. `,
  // },
  // {
  //   question: `Can eksplode guarantee the Merchant that its Members and Stars will select its products/services for promotion?`,
  //   answer: `No. whether or not an eksplode Member or eksplode Star selects a particular product or service to promote can depend on a number of factors, such as what the product or service is, and whether the reward/prize offered is alluring enough. `,
  // },
  // {
  //   question: `What happens if I participate in eksplode's vac program and my product/service is not selected by an eksplode Star for promotion? `,
  //   answer: `If your product/service is not selected within 30 days from the date the prize offered is placed in our escrow account, you may withdraw the offer at no charge and will receive your entire prize amount back, or, you may elect to let the offer sit until such time as you wish to withdraw it. `,
  // },
  // {
  //   question: ` By paying the prize to an eksplode Star for their most-liked video promoting my product/service, do I automatically own the video or intellectual property rights? `,
  //   answer: `No. All videos uploaded onto eksplode's vac platform becomes exclusive property of eksplode Marketing, including the concepts portrayed in each video, as we purchase all submissions in advance and thus own them. However, Merchants  may contact us to discuss options.`,
  // },
  // {
  //   question: `Is there a limit on number of products/services a Merchant can list on eksplode's eac or vac program?`,
  //   answer: `No. Merchant's can upload their entire catalog or list as many services as they wish to have promoted.`,
  // },
  // {
  //   question: ` Can a Merchant, participating in eksplode's vac program, renew the prize offered to ekslpode Stars for promoting the same product/service previously promoted? `,
  //   answer: `Yes. A Merchant may continue to participate in eksplode's vac program, even after a prize is rewarded to an eksplode Star, as long as the Merchant places another prize amount in eksplode's escrow account. `,
  // },
  // {
  //   question: `Can I sell anything or list any type of service on eksplode's platform? `,
  //   answer: `No. Our platform attracts participants and customers of all ages. As such, we are dedicated to maintaining Merchant catalogs of family and professional tastes. Our staff will monitor all Merchant postings to ensure all products and services offered meet our guidelines`,
  // },
  {
    question: `What if I don't have a PayPal, Venmo, or Zelle account, how will I get paid?`,
    answer: `As an alternative to those methods, we offer our own exclusive QR-coded virtual gift card (eksplode! CodeCard), which we send to your smartphone and can be use at any one of our participating Retailer outlets or online stores. (A list of participating Retailers is maintained on our Stars' Workshop page).`,
  },
  {
    question: ` What if I share my EAC with others but no one buys the product, or any other?`,
    answer: `The money rewarded to EAC Members comes from the sale that they made happen by sharing their EAC with others. If there is no sale, then there is no money generated within the system to pay you.`,
  },
  {
    question: `What if the product featured in my EAC is not purchased by the person I sent it to, but a different product is purchase by that person, will I still get paid?`,
    answer: `Yes. We require our Retailers to offer a reward amount for each and every item listed on their eksplode! catalog. Our system tracks all sales through each Members' eksplode! Code (which is linked to every EAC shared), thus, all purchases made through your EAC will be credited to you, and, you will receive the reward amount offered by the Retailer for the item purchased. In short, as long as the recipient of your EAC makes a purchase through your EAC, you get paid.`,
  },
  {
    question: ` Do I loose my reward payment if a product I promoted is returned to the Retailer for a refund?`,
    answer: ` No. Our automated system will route your reward payment directly into your PayPal, Venmo, zelle, or eksplode! CodeCard account. Whether the customer decides to return the product has nothing to do with you. You made the sale happen, you keep the money.`,
  },
];

const Faq = () => {
  let { handleSubmit, register, errors, getValues } = useForm();

  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [inputList, setInputList] = useState([
    { question: "" },
    { question: "" },
    { question: "" },
    { question: "" },
    { question: "" },
  ]);
  const [question, setQuestion] = useState(null);
  const dispatch = useDispatch();

  const next = () => {
    const status = new Notification();
    const val = getValues();
    if (val) {
      backend
        .post("/frequentlyaskquestion", val)
        .then(({ data }) => status.set_toast("success", data.mesage))
        .catch((err) => console.log(err));
    }
    setCount(+count + +1);
    setQuestion("");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuestion(value);
    const list = [...inputList];
    list[count][name] = value;
    setInputList(list);
  };

  const submitModal = () => {
    if (count == 4) {
      setOpen(false);
    } else {
      const val = getValues();
      const status = new Notification();
      dispatch(global_actions.loading(true));

      if (val) {
        backend
          .post("/frequentlyaskquestion", val)
          .then(({ data }) => {
            status.set_toast("success", data.message);
            status.show_toast();
            dispatch(global_actions.loading(false));
          })
          .catch((error) => {
            console.log(error.response);
            dispatch(global_actions.loading(false));
          });
      }
      setQuestion("");
      setCount(+count + +1);
    }
  };

  return (
    <div>
      <Breadcrumb title={"Faq"} />
      <div className="row">
        <div className="col-md-12">
          {/*Dashboard section*/}
          <section className="faq-section section-b-space">
            <div className="container">
              <h4 className="mb-2">
                Frequently Asked Questions eksplode!'s Video Ad Contest (VAC)
                Program
              </h4>
              <div className="row mb-3">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        Do I need to be a certain age to participate in
                        eksplode!'s EAC program?
                      </h5>
                    </div>

                    <div>
                      <div className="card-body">
                        <p>
                          We welcome participants 13 and older. However, if you
                          are between 13 and 17, you must have a parent or legal
                          guardian fill out and return our Parental Consent Form
                          authorizing you to participate in our program. To
                          access our form{" "}
                          <Link
                            to={`${process.env.PUBLIC_URL}/fill/consent-form`}
                          >
                            Click Here
                          </Link>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {questions.map((q, i) => (
                <div className="row mb-3" key={q.question.slice(2, 10)}>
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                          {i + 1}. {q.question}
                        </h5>
                      </div>

                      <div>
                        <div className="card-body">
                          <p>{q.answer}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="row mt-3">
                <div className="col-sm-12">
                  <button
                    className="btn btn-solid mt-2 ml-2"
                    onClick={() => setOpen(true)}
                  >
                    Submit Question(s)
                  </button>
                  {/* <Link
                    to={`${process.env.PUBLIC_URL}/vac-rules`}
                    className='btn btn-solid ml-2 mt-2'
                  >
                    View Official Rules
                  </Link> */}
                  <Link
                    to={`${process.env.PUBLIC_URL}`}
                    className="btn btn-solid ml-2 mt-2 justify-content-start"
                  >
                    HOME
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setQuestion("");
        }}
        center
      >
        <div className="container px-5 pt-5 custom-modal">
          <div className="row">
            <h4>Send us your Questions</h4>
          </div>
          <div className="form-row mr-3">
            <div className="col-md-6">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                className="form-control mb-0 "
                id="name"
                placeholder="Enter your name"
                name="name"
                ref={register({
                  required: {
                    value: true,
                    message: "This Field is Required",
                  },
                })}
              />
              <label htmlFor="name" className="error">
                {errors.name && errors.name.message}
              </label>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  className="form-control mb-0"
                  id="review"
                  placeholder="Enter your email"
                  name="email"
                  ref={register({
                    required: {
                      value: true,
                      message: "This Field is Required",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "This must be a valid Email",
                    },
                  })}
                />
                <label htmlFor="email" className="error">
                  {errors.email && errors.email.message}
                </label>
              </div>
            </div>
          </div>
          {count < 5 && (
            <div className="form-row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="question">Question:</label>
                  <textarea
                    type="text"
                    className="form-control mb-0"
                    value={question}
                    onChange={(e) => handleInputChange(e)}
                    id="question"
                    name="question"
                    placeholder="Enter your question here"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                    rows="3"
                  />
                  <label htmlFor="question" className="error">
                    {errors.question && errors.question.message}
                  </label>
                </div>
              </div>
            </div>
          )}
          <div className="row px-3 mt-2 justify-content-center">
            <button
              className="btn btn-solid mr-2 mt-2"
              onClick={handleSubmit(submitModal)}
            >
              Submit
            </button>
            {count < 5 && (
              <button
                className="btn btn-solid mr-2 mt-2
                "
                onClick={handleSubmit(next)}
              >
                Next
              </button>
            )}
            <Link
              className="btn btn-solid mr-2 mt-2"
              to={`${process.env.PUBLIC_URL}/`}
            >
              Home
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Faq;
